import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
	getGameCenterClient,
	getMetaverseJs,
	getP2pTradingClient,
	getUserIdentity,
} from '../store';
import MetaverseClient from 'metaverse-js';
import {
	setGameBalance,
	setPaymentMethods,
	setUserAssetBalances,
	setUserProfile,
} from '../reducers/user.slice';
import {
	fetchGameBalanceRequest,
	fetchPaymentMethodsRequest,
	fetchUserAssetBalancesRequest,
	fetchUserProfileRequest,
} from '../actions/user.action';
import { UserIdentityClient } from 'user-identity-js';
import { P2PTradingClient } from 'skychain-p2p-trading-js';
import { GameCenterClient } from 'skychain-game-center-js';

const getMyAssetBalances = async (metaverseJs: MetaverseClient) => {
	try {
		const res = await metaverseJs.getMyAssetBalances();
		return res;
	} catch (error) {
		console.log('getMyAssetBalances', error);
	}
};
const getUserProfile = async (
	userIdentity: UserIdentityClient,
	userId: string
) => {
	try {
		const userProfile = await userIdentity.getUser(userId);
		return userProfile;
	} catch (error) {
		console.log('getUserProfile', error);
	}
};

const getMyPaymentMethods = async (p2pTradingClient: P2PTradingClient) => {
	try {
		const res = await p2pTradingClient.getPaymentMethods();
		return res;
	} catch (error) {
		console.log('getMyPaymentMethods', error);
	}
};

const getMyAccountBalance = async (gameCenterClient: GameCenterClient) => {
	try {
		const res = await gameCenterClient.getMyAccountBalance();
		return res;
	} catch (error) {
		console.log('getMyAccountBalance', error);
	}
};

function* fechUserAssetBalances({
	payload: { onSuccess = () => null, onError = () => null },
}: any): any {
	try {
		const metaverseJs: MetaverseClient = yield select(getMetaverseJs);
		if (!metaverseJs) return;
		const res: any = yield call(getMyAssetBalances, metaverseJs);
		yield put(setUserAssetBalances(res));
		onSuccess(true);
	} catch (error) {
		onError(error);
	}
}

function* fetchUserProfile({
	payload: { userId },
}: {
	payload: { userId: string };
}): any {
	try {
		const userIdentity: UserIdentityClient = yield select(getUserIdentity);
		if (!userIdentity) return;
		const res: any = yield call(getUserProfile, userIdentity, userId);
		yield put(setUserProfile(res));
	} catch (error) {
		console.log(error);
	}
}

function* fetchPaymentMethods({ payload }: any): any {
	try {
		const p2pTradingClient: P2PTradingClient = yield select(
			getP2pTradingClient
		);
		if (!p2pTradingClient) return;
		const res: any = yield call(getMyPaymentMethods, p2pTradingClient);
		yield put(setPaymentMethods(res));
	} catch (error) {
		console.log(error);
	}
}

function* fetchAccountBalance(): any {
	try {
		const gameCenterClient: GameCenterClient = yield select(
			getGameCenterClient
		);
		if (!gameCenterClient) return;
		const response = yield call(getMyAccountBalance, gameCenterClient);
		yield put(setGameBalance(response));
	} catch (error: any) {
		console.log(error);
		yield put(
			setGameBalance({
				availableBalance: '0',
			})
		);
	}
}

export function* userSaga() {
	yield takeLatest(fetchUserAssetBalancesRequest, fechUserAssetBalances);
	yield takeLatest(fetchUserProfileRequest, fetchUserProfile);
	yield takeLatest(fetchPaymentMethodsRequest, fetchPaymentMethods);
	yield takeLatest(fetchGameBalanceRequest, fetchAccountBalance);
}
